import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  orgDataService,
  vmSharedModelService
} from 'app/services';
import {
  actionIcon,
  alerts,
  documentManagement,
  customerServiceAcceptanceDialog,
  appReports
} from 'app/components/global';
import editVendorDialog from './vendors/dialog.editVendorDialog';
import vmSettings from './settings';
import notifications from './notifications';
import vendors from './vendors';
import controller from './vendor-management.controller';
import directive from './vendor-management.directive';


export const routeConfig = {
  template: require('./vendor-management.html'),
  controller: 'VendorManagementController',
  controllerAs: 'vendorManagementVM',
};

export default angular.module('app.components.advisory.vendorManagement', [
  appReports,
  notifications,
  vendors,
  actionIcon,
  alerts,
  constants,
  documentManagement,
  loaderService,
  notifications,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  orgDataService,
  vmSharedModelService,
  vendors,
  vmSettings,
  editVendorDialog,
  customerServiceAcceptanceDialog,
])
  .directive('vmVendorManagement', directive)
  .controller('VendorManagementController', controller)
  .name;

console.log('app.components.advisory.vendorManagement created');
